// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountExternalIdSaveThirdPartyIdSaveThirdPartyIdResponse {
    static getAttributeTypeMap() {
        return AccountExternalIdSaveThirdPartyIdSaveThirdPartyIdResponse.attributeTypeMap;
    }
}
AccountExternalIdSaveThirdPartyIdSaveThirdPartyIdResponse.discriminator = undefined;
AccountExternalIdSaveThirdPartyIdSaveThirdPartyIdResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=accountExternalIdSaveThirdPartyIdSaveThirdPartyIdResponse.js.map